import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=e8758726&scoped=true&"
import script from "./MainPage.vue?vue&type=script&lang=ts&"
export * from "./MainPage.vue?vue&type=script&lang=ts&"
import style0 from "./MainPage.vue?vue&type=style&index=0&id=e8758726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8758726",
  null
  
)

export default component.exports